import React, { forwardRef } from 'react'

import { IconProps } from './types'

const NoFilter = forwardRef<SVGSVGElement, IconProps>(
  ({ size, ...props }, ref) => (
    <svg
      ref={ref}
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.5 2.5H13.5V5L10 8.5M9.5 11.25V12.5L6.5 14V9.5L2.5 5V4.5M2 2L13 13"
        stroke="currentColor"
      />
    </svg>
  ),
)
NoFilter.displayName = 'NoFilter'

export default NoFilter
